<template>
  <div class="w-100 d-flex flex-column">
    <template v-for="(tagField, idx) in tagFields">
      <hr
        :key="makeUniqueKey('hr', tagField)"
        v-if="idx !== 0 && layout !== 'dropdown'"
        class="mt-3 w-100"
      />
      <TagFieldEditor
        :key="makeUniqueKey('tagEditor', tagField)"
        :value="currentValue[tagField.id]"
        @input="handleInput(tagField.id, $event)"
        :tagField="tagField"
        :isEditing="isEditing"
        :objectId="objectId"
        :layout="layout"
        :class="[idx === 0 ? '' : 'mt-3']"
      />
    </template>
  </div>
</template>

<script>
  import TagFieldEditor from './TagFieldEditor.vue';
  import cloneDeep from 'lodash/cloneDeep';

  export default {
    name: 'TagFieldList',
    components: { TagFieldEditor },
    props: {
      tagFields: {
        type: Array,
        required: true,
      },
      isEditing: {
        type: Boolean,
        required: true,
        default: false,
      },
      value: {
        type: Object,
        required: true,
      },
      objectId: {  // empty if we are creating a new object, otherwise the ID of the object we are tagging
        type: String,
        required: false,
      },
      layout: {
        type: String,
        default: 'vertical',  // options are 'horizontal' or 'vertical' or 'dropdown' (select for single, multiselect for multiple)
      },
    },
    computed: {
      currentValue: {
        // This is needed to avoid when the tagFieldId is not present in the value object
        get() {
          return this.value;
        },
        set(value) {
          console.log('from TagFieldList currentValue set - value', value);
          this.$emit('input', value);
        },        
      },
    },
    methods: {
      makeUniqueKey(prefix, tagField) {
        // to use in various :key attributes above
        return `${prefix}-${this.objectId ? this.objectId : ''}-${tagField.id}`;
      },
      getValueForTagField(tagField) {
        const originalArray = this.value[tagField.id] ?? [];
        return cloneDeep(originalArray);
      },
      handleInput(tagFieldId, newTags) {
        // console.log('from TagFieldList handleInput - tagFieldId, newTags', tagFieldId, newTags);
        //this.$set(this.currentValue, tagFieldId, newValue);
        const newValue = cloneDeep(this.value);
        newValue[tagFieldId] = newTags;
        //this.$set(this.currentValue, tagFieldId, newValue);
        this.$emit('input', newValue);
      },
    },
  };
</script>
